'use client';
import type { SVGProps } from "react";
import type { FC } from 'react';
import type { IconProps } from '../utils/type';
import { SvgIconWrapper } from '../utils/svg-icon-wrapper';
/**
 * Auto-generated icon component: Do not change this component manually.
 * Config file: customSvgrTemplate.js
 */
const SvgBase: FC<IconProps> = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 25 24" {...props}><path fill="currentColor" fillRule="evenodd" d="M13.596 4.5a5 5 0 0 1 8.66 5l-3 5.197a5 5 0 1 1-8.66-5 1 1 0 0 1 1.732 1 3 3 0 0 0 5.196 3l3-5.196a3 3 0 0 0-5.196-3 1 1 0 1 1-1.732-1M6.632 8.564a5 5 0 0 1 8.66 5 1 1 0 1 1-1.732-1 3 3 0 1 0-5.196-3l-3 5.196a3 3 0 1 0 5.196 3 1 1 0 0 1 1.732 1 5 5 0 0 1-8.66-5z" clipRule="evenodd" /></svg>;
const IconLink = ({
  $size,
  $color,
  className,
  ...rest
}: IconProps) => <SvgIconWrapper $size={$size} $color={$color} className={className}><SvgBase {...rest} /></SvgIconWrapper>;
export default IconLink;